import Pie from '../ui/PieChart';

export const UsageBot = ({ use, total }: { use: number; total?: number }) => {
  const getTotal = () => {
    if (total == -1) {
      return <span className="tw-text-xl">∞</span>;
    } else {
      return total ?? 0;
    }
  };

  return (
    <div>
      <div className="lg:tw-col-span-6 tw-col-span-12 tw-flex tw-items-start lg:tw-justify-end tw-justify-between">
        <div className="tw-justify-start tw-items-center tw-gap-2 tw-flex">
          <div className="tw-flex-col tw-justify-center tw-items-end tw-inline-flex">
            <div className="tw-text-gray-700 tw-text-base tw-font-medium tw-font-['Lexend'] tw-leading-normal">
              {use}
              {' / '}
              {getTotal()}
            </div>
          </div>
          <div className="tw-w-10 tw-h-10 tw-relative">
            <Pie percentageFull={(100 * (use ?? 0)) / (total ?? 0)} />
          </div>
        </div>
      </div>
    </div>
  );
};
